import api from './api';
import s3Service from './s3.service';

class MemberService {
  async getAllMembers(params = {}) {
    const response = await api.get('/members', { params });
    return response.data;
  }

  async getMemberById(id) {
    const response = await api.get(`/members/${id}`);
    return response.data;
  }

  // Legacy: Server-side upload using multipart/form-data
  async createMember(formData) {
    const response = await api.post('/members', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  // Legacy: Server-side upload using multipart/form-data
  async updateMember(id, formData) {
    const response = await api.put(`/members/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  // New: Client-side upload using signed URLs
  async createMemberWithSignedUrl(memberData, photoFile, onProgress = null) {
    let photoUrl = null;

    // If photo file is provided, upload to S3 first
    if (photoFile) {
      const { fileUrl } = await s3Service.uploadFile(
        photoFile,
        'members',
        onProgress
      );
      photoUrl = fileUrl;
    }

    // Create member with photo URL
    const response = await api.post('/members', {
      ...memberData,
      photo: photoUrl,
    });

    return response.data;
  }

  // New: Client-side upload using signed URLs
  async updateMemberWithSignedUrl(id, memberData, photoFile, onProgress = null) {
    let photoUrl = memberData.photo; // Keep existing photo if no new file

    // If new photo file is provided, upload to S3
    if (photoFile) {
      const { fileUrl } = await s3Service.uploadFile(
        photoFile,
        'members',
        onProgress
      );
      photoUrl = fileUrl;
    }

    // Update member with photo URL
    const response = await api.put(`/members/${id}`, {
      ...memberData,
      photo: photoUrl,
    });

    return response.data;
  }

  async deleteMember(id) {
    const response = await api.delete(`/members/${id}`);
    return response.data;
  }

  async freezeMembership(id, data) {
    const response = await api.post(`/members/${id}/freeze`, data);
    return response.data;
  }

  async unfreezeMembership(id) {
    const response = await api.post(`/members/${id}/unfreeze`);
    return response.data;
  }

  async getMemberAttendance(id, params = {}) {
    const response = await api.get(`/members/${id}/attendance`, { params });
    return response.data;
  }

  async getMemberProgress(id) {
    const response = await api.get(`/members/${id}/progress`);
    return response.data;
  }

  async addMemberProgress(id, data) {
    const response = await api.post(`/members/${id}/progress`, data);
    return response.data;
  }
}

export default new MemberService();
